export const ADD_OTHER_THEATRE = 'ADD_OTHER_THEATRE'
export const GET_OTHER_THEATRE = 'GET_OTHER_THEATRE'
export const UPDATE_OTHER_THEATRE = 'UPDATE_OTHER_THEATRE';
export const DELETE_OTHER_THEATRE = 'DELETE_OTHER_THEATRE';
export const TOGGLE_DIALOG_OTHER_THEATRE = 'TOGGLE_DIALOG_OTHER_THEATRE';
export const SELECT_OTHER_THEATRES = 'SELECT_OTHER_THEATRES';
export const SELECT_ALL_OTHER_THEATRES = 'SELECT_ALL_OTHER_THEATRES';